import type { Project } from '../types';

export function normalizeVitrineZoneKey(zoneTypeRaw?: string | null): string {
  return String(zoneTypeRaw ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function isBureauxVitrineZone(zoneTypeRaw?: string | null): boolean {
  return normalizeVitrineZoneKey(zoneTypeRaw).includes('bureau');
}

export function isActivitesVitrineZone(zoneTypeRaw?: string | null): boolean {
  const key = normalizeVitrineZoneKey(zoneTypeRaw);
  return (
    key.includes('activit') ||
    key.includes('locaux_activ') ||
    key.includes('entrepot') ||
    key.includes('logistique')
  );
}

export function isBureauxProjectType(type?: Project['type'] | string): boolean {
  const t = String(type ?? '').toLowerCase();
  return t === 'bureaux' || t === 'bureau' || t.includes('bureau');
}

export function isActivitesProjectType(type?: Project['type'] | string): boolean {
  const t = String(type ?? '').toLowerCase();
  return (
    t === 'activites' ||
    t === 'local' ||
    t.includes('activit') ||
    t.includes('locaux_activ')
  );
}

export function vitrineUnitsCountLabelFromZone(zoneTypeRaw?: string | null): string {
  if (isBureauxVitrineZone(zoneTypeRaw)) return 'Nombre de plateaux';
  if (isActivitesVitrineZone(zoneTypeRaw)) return 'Nombre de cellules';
  return 'Nombre de logements';
}

export function vitrineUnitsCountPlaceholderFromZone(zoneTypeRaw?: string | null): string {
  if (isBureauxVitrineZone(zoneTypeRaw)) return 'Ex. 2 à 8';
  if (isActivitesVitrineZone(zoneTypeRaw)) return 'Ex. 1 à 4';
  return 'Logements';
}

export function vitrineUnitsCountLabel(type?: Project['type'] | string): string {
  if (isBureauxProjectType(type)) return 'Nombre de plateaux';
  if (isActivitesProjectType(type)) return 'Nombre de cellules';
  return 'Nombre de logements';
}

export function vitrineUnitsCountPlaceholder(type?: Project['type'] | string): string {
  if (isBureauxProjectType(type)) return 'Ex. 2 à 8';
  if (isActivitesProjectType(type)) return 'Ex. 1 à 4';
  return 'Logements';
}

/** Libellé page détail : zone Firestore en priorité, sinon type projet mappé. */
export function vitrineUnitsCountLabelForListing(
  zoneType?: string | null,
  classification?: string | null,
  projectType?: Project['type'] | string,
  customLabel?: string | null,
): string {
  const custom = String(customLabel ?? '').trim();
  if (custom) return custom;
  const zone = zoneType || classification;
  if (zone?.trim()) return vitrineUnitsCountLabelFromZone(zone);
  return vitrineUnitsCountLabel(projectType);
}

export function vitrineUnitsCountPlaceholderForListing(
  zoneType?: string | null,
  classification?: string | null,
  projectType?: Project['type'] | string,
): string {
  const zone = zoneType || classification;
  if (zone?.trim()) return vitrineUnitsCountPlaceholderFromZone(zone);
  return vitrineUnitsCountPlaceholder(projectType);
}
